import React, { useState, useEffect, useRef } from 'react';
import { makeStyles, withStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Checkbox from "@mui/material/Checkbox";
import { Link } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import MedalIcon from '../../sharedComponents/customIcons/MedalIcon';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Switch from "@mui/material/Switch";
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DataMapper from "../../common/DataMapper";
import VpnKeyTwoToneIcon from '@mui/icons-material/VpnKeyTwoTone';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(1)
        },
    },
    gridItem: {
        [theme.breakpoints.up('sm')]: {
            width: '100%',
            padding: theme.spacing(1)
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            paddingBottom: theme.spacing(1)
        },
    },
    Name: {
        fontWeight: 'bold',
        fontSize: '18px',
        textDecoration: 'none',
        color: '#393939'
    },
    tableRow: {
        // height: '100px !important',
        // boxShadow: '1px 1px 1px #aaaaaa',
        '& td:nth-of-type(4)': {
            paddingRight: theme.spacing(1),
        }
    }
}));

export default function UserList(props) {
    const classes = useStyles();
    const [isActive, setIsActive] = useState(props.data.isActive);

    useEffect(() => {
        setIsActive(props.data.isActive);
    }, [props.data])

    const handleStatusChange = (event) => {
        var status = event.target.checked;
        setIsActive(status);
        let postData = { "id": props.data.id, "userName": props.data.userName, "email": props.data.email, "isActive": status, "role": props.data.role }
        props.handleStatusChange(postData);
    }
    const onEditClick = () => {
        props.onEditClick(props.data);
    }
    const checkProfileCheckbox = (userId) => {
		return props.selectedUsers?  props.selectedUsers.includes(userId):false;
	}

   const onChangePasswordClick=()=>{
    props.onChangePasswordClick(props.data);
   }

    return (
        <>
            <TableRow className={classes.tableRow}>
                {props.showCheckBox && props.showCheckBox == true &&
                    <TableCell align="left" style={{ width: '3%' }} >
                        <Checkbox
                            name="chkGroup"
                            id={props.data.userName}
                            checked={checkProfileCheckbox(props.data.userName)}
                            onChange={(event) => props.handleUserChecked(event, props.data.userName)}
                            color="secondary"
                        />
                    </TableCell>}
                <TableCell align="left" style={{ width: '20%' }} >
                    <Typography variant="body2"> {props.data.firstName} {props.data.lastName} </Typography>
                </TableCell>
                <TableCell align="left" style={{ width: '20%' }} >
                    <Typography variant="body2">
                        {props.data.userName}</Typography>
                </TableCell>
                <TableCell align="left" style={{ width: '27%' }}>
                    <Typography color="primary" variant="body2">{props.data.email}</Typography>
                </TableCell>
                <TableCell align="left" style={{ width: '20%' }}>
                    <Typography variant="body2" color="primary">{DataMapper.GetTextByValue(props.data.role)}</Typography>
                </TableCell>
                <TableCell align="left" style={{ width: '5%' }}>
                    <Tooltip title={isActive == true ? 'Deactivate User' : 'Activate User'}>
                        <Switch
                            size="small"
                            checked={isActive ? isActive : false}
                            onChange={(e) => handleStatusChange(e)}
                            color='primary'
                        />
                    </Tooltip>
                </TableCell>
                <TableCell align="left" style={{ width: '5%' }}>
                    <Tooltip title="Edit" onClick={onEditClick} style={{ cursor: "pointer" }}>
                        <EditTwoToneIcon color="primary" />
                    </Tooltip>
                </TableCell>
                <TableCell align="left" style={{ width: '5%' }}>
                    <Tooltip title="Change Password" onClick={onChangePasswordClick} style={{ cursor: "pointer" }}>
                        <VpnKeyTwoToneIcon color="primary" />
                    </Tooltip>
                </TableCell>
            </TableRow>
        </>
    )
}